import { render } from "./Overview.vue?vue&type=template&id=0fff9ff9"
import script from "./Overview.vue?vue&type=script&lang=ts"
export * from "./Overview.vue?vue&type=script&lang=ts"
script.render = render

export default script